import { cloneDeep } from 'lodash';
import { generateId, comparePeriodStartTime } from './utils';
import { Airing, Highlight, Period } from '../../../utils/types';

export const build = (airing: Airing, source: Highlight, destination: Highlight): Highlight => {
	const sourcePeriods = cloneDeep(source.periods?.items) || [];
	const destinationPeriods = cloneDeep(destination.periods?.items) || [];

	if (destination?.periods?.items) {
		destination.periods.items = pickPeriods(sourcePeriods, destinationPeriods);

		destination.periods.items = destination.periods.items.map((item: Period) => {
			item.source.channelId = airing.channelId;
			return item;
		});

		destination.periods.items.sort(comparePeriodStartTime);
	}

	destination.id = generateId();
	destination.airingId = airing.id;
	destination.channelId = airing.channelId;
	destination.type = 'LIVE';

	return destination;
};

const pickPeriods = (sourcePeriods: Period[], destinationPeriods: Period[]): Period[] => {
	const sourceTextPeriods = sourcePeriods.filter((period: Period) => period.type === 'Text');

	const sourceNonTextPeriods = sourcePeriods.filter((period: Period) => period.type !== 'Text');

	const destinationPeriodsMap: {
		[key: string]: Period;
	} = destinationPeriods.reduce((accumulator, period: Period) => (period.playId ? { ...accumulator, [period.playId]: period } : accumulator), {});

	const newDestinationPeriods = [...sourceTextPeriods];

	sourceNonTextPeriods.forEach((period: Period) => {
		const playId = period?.playId || '';
		if (playId in destinationPeriodsMap) {
			const destinationPeriod = destinationPeriodsMap[playId];
			period.source = { ...period.source, startTime: destinationPeriod.source.startTime, endTime: destinationPeriod.source.endTime };
			newDestinationPeriods.push(period);
		}
	});

	return newDestinationPeriods;
};
